import { useForm } from 'react-hook-form'

import { PhoneField } from '@/features/update-user-information'
import {
  PhoneVerificationButton,
  type PhoneVerificationResult,
  type TPhoneVerificationForm,
} from '@/features/verify-identity'
import { cn } from '@/shared/lib'
import { Form } from '@/shared/ui'

type Props = {
  isVerified?: boolean
  onSuccess: (result: PhoneVerificationResult) => void
  className?: string
}

export const PhoneVerification = ({
  isVerified = false,
  onSuccess,
  className,
}: Props) => {
  const form = useForm<TPhoneVerificationForm>()

  const handleVerificationSuccess = (result: PhoneVerificationResult) => {
    form.setValue('phoneNumber', result.phoneNumber)
    onSuccess(result)
  }

  return (
    <section
      className={cn(
        'flex h-57 flex-col justify-between rounded-lg border border-black bg-white p-[39px]',
        className,
      )}
    >
      {!isVerified && (
        <p className="typo-body1">
          안전한 계약을 위해
          <br />
          <strong className="font-semibold text-purple-500">
            본인 인증 절차가 반드시 필요합니다.
          </strong>
        </p>
      )}
      <Form.Root form={form}>
        <div className="flex flex-col gap-6">
          {isVerified && <PhoneField />}
          <PhoneVerificationButton
            disabled={isVerified}
            onSuccess={handleVerificationSuccess}
          >
            {isVerified ? '휴대폰 본인인증 완료' : '휴대폰 본인인증'}
          </PhoneVerificationButton>
        </div>
      </Form.Root>
    </section>
  )
}
